<template>
    <div>
        <div class="row form-group">
            <div class="col-md-6">
                <label>CEP:</label>
                <input
                    id='cep'
                    v-mask="'#####-###'"
                    name="cep" v-on:blur="validaCep()"
                    type="text" v-model="address.zip"
                    required
                    class="form-control"
                >
            </div>
            <div class="col-md-6">
                <label>Número:</label>
                <input
                    id='numero'
                    type="text"
                    name="numero"
                    v-model="address.number"
                    required
                    class="form-control"
                >
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-6">
                <label>Rua:</label>
                <input
                    id='rua'
                    type="text"
                    name="rua"
                    v-model="address.street"
                    required
                    class="form-control"
                >
            </div>
            <div class="col-md-6">
                <label>Bairro:</label>
                <input
                    id='bairro'
                    type="text"
                    name="bairro"
                    v-model="address.neighborhood"
                    required
                    class="form-control"
                >
            </div>
        </div>
        <div class="row form-group">
            <div class="col-md-6">
                <label>Cidade:</label>
                <input
                    id='cidade'
                    type="text"
                    name="cidade"
                    v-model="address.city"
                    required
                    class="form-control"
                >
            </div>
            <div class="col-md-6">
                <label>Estado:</label>
                <input
                    id='estado'
                    type="text"
                    name="estado"
                    v-model="address.state"
                    required
                    class="form-control"
                >
            </div>
        </div>
    </div>

</template>

<script>

import AuthController from "./../../controllers/AuthController.js";
import AddressController from "./../../controllers/AddressController.js";
import Address from "./../../models/Address.js";

const axios = require('axios');

export default {

    data() {
        return {
            authController: new AuthController(
                this.$resource,
                this.$router,
                this.$message
            ),

        };
    },

    props: {
        address: {
            required: false,
            types: [Array, Address],
            street: null,
            zip: null,
            street : null,
            city: null,
            neighborhood: null,
            state: null,
        },
        saveAlterAddress:{
            require: false
        }
    },

    methods: {
        validaCep(){

            let cep = this.address.zip
            let endereco = {
                street: null,
                zip: null,
                street : null,
                city: null,
                neighborhood: null,
                state: null,
            }

            axios
                .get(`https://viacep.com.br/ws/${cep}/json/`)
                .then((response) => {

                       this.address.state =        response.data.uf
                       this.address.street =       response.data.logradouro
                       this.address.city =         response.data.localidade
                       this.address.neighborhood = response.data.bairro

                    }
                ).catch(error => {
                    this.$awn.alert("CEP inváildo!");
                })
        },

    }
};


</script>

<style scoped>
.sidebar-bg {
	position: absolute;
	left: 0;
	top: 0;
	z-index: -1;
	opacity: 0;
	background-color: rgba(255,255,255,0.7);
	transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
}
</style>
